var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetprofit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 8.75L22.5821 16.7929C22.1916 17.1834 21.5584 17.1834 21.1679 16.7929L18.2071 13.8321C17.8166 13.4416 17.1834 13.4416 16.7929 13.8321L10.2083 20.4167",
    stroke: "#BB2677",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 4.375V27.425C4.375 28.5451 4.375 29.1052 4.59299 29.533C4.78473 29.9093 5.09069 30.2153 5.46702 30.407C5.89484 30.625 6.4549 30.625 7.575 30.625H30.625",
    stroke: "#BB2677",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetprofit);
export default __webpack_public_path__ + "static/media/Netprofit.ce7eeed9a69a978b54709df9351c4c58.svg";
export { ForwardRef as ReactComponent };